import React, { useState } from "react";
import MuiButton from "../../shares/MuiButton";
import PanelTemplate from "../../shares/PanelTemplate";
import PanelFilter from "../../shares/PanelFilter";
import CustomerMessageCard from "./CustomerMessageCard";
import MuiPagination from "../../shares/MuiPagination";
import useFetch from "../../../context/useFetch";
import { toast } from "react-toastify";
import { useUserData } from "../../../context/UserDataContext";

const CustomerMessages = (props) => {
  const [isFilterOn, setIsFilterOn] = useState(false);
  const [nameFilter, setNameFilter] = useState(null);
  const [messageList, setMessageList] = useState({ results: [] });

  const { userData } = useUserData();

  const getListOfCustomerApi = useFetch({
    trigger: true,
    method: "get",
    url: `User_Service/${userData.username}/get_notifs`,
    argFunc: (res) => {
      setMessageList(res);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  // Filter
  const filterList = [
    {
      type: "textField",
      label_fa: "موضوع",
      label_en: "name",
      state: nameFilter,
    },
  ];

  const update_filter = (state, e) => {
    if (state == "name") setNameFilter(e.length > 0 ? e : null);
  };
  const filter = () => {
    if (nameFilter !== null) {
      setIsFilterOn(true);
      // getCitiesApi.reFetch();
    }
  };

  const reset_filter = () => {
    setNameFilter(null);
    // getCitiesApi.reFetch();
  };

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setMessageList({ results: [] });

    // getCitiesApi.reFetch();
  };

  return (
    <>
      <PanelTemplate sidebarActiveLink="messages">
      <div className="panel-main-header">
            <span>پیام ها </span>
          </div>
          <PanelFilter
            header="فیلتر پیام‌ها:"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />

        {messageList.results.map((item, index) => {
          return [<CustomerMessageCard notif={item} />];
        })}

        {/* <AdminMessageCard /> */}

        <MuiPagination
          onChange={onChangePage}
          count={Math.ceil(
            paginationPageInfo.count / paginationPageInfo.pageSize
          )}
        />
      </PanelTemplate>
    </>
  );
};

export default CustomerMessages;
